import { Skeleton } from '@/components/atoms/Skeleton/Skeleton';
import { LEADER_INSIGHT_ROW_TEST_IDS } from '@/constants/data-testids';

import { TableCell, TableRow } from '../Table/Table';

export const LeaderInsightRowSkeleton = () => {
  return (
    <TableRow data-testid={LEADER_INSIGHT_ROW_TEST_IDS.SKELETON}>
      <TableCell className="w-full flex items-center gap-2">
        <Skeleton className="h-[14px] w-full rounded-full size-8 shrink-0" />
        <div className="w-full">
          <Skeleton className="h-[14px] w-full mb-1.5" />
          <Skeleton className="h-[14px] w-2/3" />
        </div>
      </TableCell>
      <TableCell>
        <Skeleton className="h-[14px] w-full" />
      </TableCell>
      <TableCell>
        <Skeleton className="h-[14px] w-full" />
      </TableCell>
      <TableCell>
        <Skeleton className="h-[14px] w-full" />
      </TableCell>
      <TableCell>
        <Skeleton className="h-[14px] w-full" />
      </TableCell>
      <TableCell>
        <Skeleton className="h-[14px] w-full" />
      </TableCell>
    </TableRow>
  );
};
